module.exports = __webpack_public_path__ + "img/教师.977c3378.png";